import { normalizeName } from './normalize';
import type { FunnelConfig } from './types';

export interface MediumCatalogEntry {
  name: string;
  categoryCode: string;
}

/**
 * Resuelve la categoría de un medio de captación contra el catálogo (comparación normalizada).
 * Devuelve `fallback` (por defecto 'OTROS') si no hay coincidencia.
 */
export function resolveMediumCategory(
  medium: string | null | undefined,
  catalog: readonly MediumCatalogEntry[],
  fallback: string | null = 'OTROS',
): string | null {
  if (!medium) return fallback;
  const key = normalizeName(medium);
  const exact = catalog.find((c) => normalizeName(c.name) === key);
  if (exact) return exact.categoryCode;
  const partial = catalog.find((c) => key.includes(normalizeName(c.name)));
  return partial ? partial.categoryCode : fallback;
}

/**
 * Nombre canónico del catálogo cuando el texto coincide con un medio (comparación normalizada: «facebook» → «FACEBOOK»).
 * Null si no coincide exactamente: un texto libre («Referido de Juan», «Meta ads») se guarda tal cual.
 */
export function resolveMediumName(
  medium: string | null | undefined,
  catalog: readonly MediumCatalogEntry[],
): string | null {
  if (!medium) return null;
  const key = normalizeName(medium);
  return catalog.find((c) => normalizeName(c.name) === key)?.name ?? null;
}

export function isDigitalCategory(
  category: string | null | undefined,
  config: FunnelConfig,
): boolean {
  return !!category && config.digitalCategories.includes(category);
}

export function isPautaCategory(
  category: string | null | undefined,
  config: FunnelConfig,
): boolean {
  return !!category && config.pautaCategories.includes(category);
}

export function isPortalCategory(
  category: string | null | undefined,
  config: FunnelConfig,
): boolean {
  return !!category && config.portalCategories.includes(category);
}
